<div class="modal-container">
  <div class="modal-content">
    <div *ngIf="headerImageUrl" class="header-section">
      <div class="header-image" [style.backgroundImage]="'url(' + headerImageUrl + ')'"></div>
    </div>

    <div class="details-section">
      <h1 *ngIf="title" class="title" [style.textAlign]="titleCentered ? 'center' : 'unset'">{{ title }}</h1>
      <p *ngIf="description" class="description" [style.textAlign]="descriptionCentered ? 'center' : 'unset'" [innerHTML]="description"></p>

      <ng-container *ngFor="let additionalContent of descriptionAdditionalContent; let i = index">
        <p
          tappable
          class="description"
          [style.textAlign]="descriptionCentered ? 'center' : 'unset'"
          [innerHTML]="additionalContent.text"
          (click)="onHandleAdditionalContentClick(i)"
        ></p>
      </ng-container>
    </div>

    <div class="footer-section">
      <ion-button expand="block" class="custom-button" (click)="onDismiss()" color="grey">{{ "OKAY" | translate }}</ion-button>
    </div>
  </div>
</div>
